import React from "react";
import PropTypes from "prop-types";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { makeStyles } from "@material-ui/core/styles";
import { SwatchesPicker } from "react-color";

const theme = createMuiTheme({
  palette: {
    error: {
      main: "#3f51b5",
    },
  },
});

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 120,
  },
  selectMenu: { paddingTop: 6, fontSize: 12 },
}));

function EditColorPicker(props) {
  const [, setBeginValue] = React.useState(props.value);

  const getField = (write) => {
    return (
      <ThemeProvider theme={theme}>
        {props.value ? (
          <SwatchesPicker
            color={props.value}
            onChange={(color) => {
              if (write) {
                props.onChange(color.hex, setBeginValue);
              }
            }}
          />
        ) : (
          <SwatchesPicker
            onChange={(color) => {
              if (write) {
                props.onChange(color.hex, setBeginValue);
              }
            }}
          />
        )}
      </ThemeProvider>
    );
  };

  return props.authorizationField ? (
    <AuthorizationWrapper
      permission={props.authorizationField}
      child={(write) => {
        return getField(write);
      }}
    />
  ) : (
    getField(true)
  );
}

EditColorPicker.propTypes = {
  authorizationField: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default EditColorPicker;
